import { CheckCircle, AlertTriangle, XCircle, MinusCircle } from 'lucide-react';

const SERVICES = [
  { key: 'management_ui', label: 'Management UI access' },
  { key: 'api', label: 'API' },
  { key: 'radius', label: 'Radius authentication' },
  { key: 'device_admin', label: 'Device administration' },
  { key: 'external_integrations', label: 'External integrations' },
];

const STATUS_CONFIG = {
  operational: {
    icon: <CheckCircle className="w-4 h-4 text-green-600" />,
    label: 'Operational',
    textColor: 'text-green-700',
  },
  degraded: {
    icon: <AlertTriangle className="w-4 h-4 text-yellow-500" />,
    label: 'Degraded',
    textColor: 'text-yellow-700',
  },
  outage: {
    icon: <XCircle className="w-4 h-4 text-red-600" />,
    label: 'Outage',
    textColor: 'text-red-700',
  },
  not_available: {
    icon: <MinusCircle className="w-4 h-4 text-gray-500" />,
    label: 'Not Available',
    textColor: 'text-gray-600',
  },
};

export default function ServiceStatusList({ serviceStatuses }) {
  return (
    <div className="mb-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-2 uppercase tracking-wide">Service Status</h3>
      <div className="divide-y divide-gray-100 border border-gray-200 rounded">
        {SERVICES.map(({ key, label }) => {
          const statusKey = serviceStatuses?.[key] || 'not_available';
          const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG['not_available'];
          return (
            <div key={key} className="flex items-center justify-between px-3 py-2 bg-white">
              <span className="text-sm text-gray-700">{label}</span>
              <div className="flex items-center gap-1.5">
                {config.icon}
                <span className={`text-sm font-medium ${config.textColor}`}>{config.label}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
